<template>
  <div>
    <v-card>
      <v-data-table
          v-model="table.selected"
          :headers="table.headers"
          :items="locations ? locations.data : []"
          :server-items-length="totalItems"
          :items-per-page="locations && locations.meta ? parseInt(locations.meta.per_page) : 0"
          :page.sync="table.page"
          :options.sync="table.options"
          :sort-by.sync="table.sortBy"
          :sort-desc.sync="table.sortDesc"
          :loading="table.loading"
          item-key="id"
          hide-default-footer
          @click:row="onItemClick"
      >
        <template v-slot:footer>
          <v-pagination
              class="mb-4"
              v-model="table.page"
              :length="totalPages"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar v-model="snackbar.show" timeout="3000" :color="snackbar.color">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {handleResponseError} from '@/api/handleError'

export default {
  name: 'LocationsTable',
  props: {
    params: {
      ids: Array,
      account: String,
      allSelected: Boolean,
      filters: Object,
    },
  },
  computed: {
    ...mapState({
      accounts: state => state.accounts.all,
      locations: state => state.locations.bulk,
    }),
    totalItems: function () {
      return this.locations && this.locations.meta ? parseInt(this.locations.meta.total) : 0
    },
    /**
     * Número de páginas
     * @returns {number|number}
     */
    totalPages() {
      return this.locations && this.locations.meta
          ? Math.ceil(parseInt(this.locations.meta.total) / parseInt(this.locations.meta.per_page))
          : 0
    }
  },
  mounted() {
    if (this.params.filters) {
      this.filters = this.params.filters
    }
    this.filters.account = this.params.account
  },
  data: () => ({
    snackbar: {
      text: '',
      show: false,
      color: 'info',
    },
    filters: {
      search: '',
      account: null,
      state: null,
      city: null,
      params: {
        allSelected: 0,
        account: '',
        ids: [],
        accountName: '',
      },
    },
    table: {
      action: null,
      allSelected: false,
      selected: [],
      unSelected: [],
      page: 1,
      sortBy: null,
      sortDesc: false,
      options: {},
      loading: false,
      headers: [
        { text: 'Código', value: 'store_code', align: 'start' },
        { text: 'Nome', value: 'location_name' },
        { text: 'Endereço', value: 'address.address_line_one' },
        { text: 'Cidade', value: 'address.locality' },
        { text: 'Estado', value: 'address.administrative_area' },
        { text: 'Labels', value: 'labels', sortable: false },
      ],
    },
    sortBy: '',
    sortDesc: '',
    page: 1,
    limit: 15,
    bulkUpdate: false,
  }),
  methods: {
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    fetchLocations: async function () {
      let sortBy = this.sortBy
      if (this.sortBy && this.sortBy.toString().includes('.')) {
        sortBy = this.sortBy.toString().split('.')[1]
      }

      const payload = {
        params: this.params,
        account: this.filters.account,
        city: this.filters.city,
        state: this.filters.state,
        search: this.filters.search,
        limit: 10,
        page: this.page,
        sort_direction: this.sortDesc ? 'desc' : 'asc',
        sort: sortBy,
      }

      this.table.loading = true
      await this.$store.dispatch('locations/getBulk', payload).catch(e => {
        const message = handleResponseError(e, 'Ocorreu um erro ao buscar os locais.')
        this.showNotification(message, 'red darken-2')
        this.table.loading = false
      })
      this.table.loading = false
    },
    onItemClick: function (location) {
      this.$router.push('/location/' + location.id)
    },
  },
  watch: {
    'table.options': function (options, oldOptions) {
      const sortDesc = options.sortDesc[0]
      let sortBy = options.sortBy[0]
      if ((sortBy || '').includes('formatted')) {
        sortBy = sortBy.split('_formatted')[0]
      }

      this.sortBy = sortBy
      this.sortDesc = sortDesc
      this.page = options.page

      const shouldFetchLocations = function() {
        if (options.page !== oldOptions.page) {
          return true
        }
        if (options.sortBy !== oldOptions.sortBy) {
          return true
        }
        return options.sortDesc !== oldOptions.sortDesc;
      }

      if (shouldFetchLocations()) {
        this.fetchLocations()
      }
    },
  },
}
</script>